import { userConstants } from './../constants/user.constants';

const initialState = {};

export function callBankdetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.CALLBANKDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.CALLBANKDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.CALLBANKDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}